/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LlmProviderInfo } from '../../models/llm-provider-info';

export interface LlmControllerGetProviderList$Params {
}

export function llmControllerGetProviderList(http: HttpClient, rootUrl: string, params?: LlmControllerGetProviderList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LlmProviderInfo>>> {
  const rb = new RequestBuilder(rootUrl, llmControllerGetProviderList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LlmProviderInfo>>;
    })
  );
}

llmControllerGetProviderList.PATH = '/llm/providerList';
